import {
  Component, HostListener, OnInit,
  ViewChild

} from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { MessageService } from "primeng/primeng";
import { ChallengeService } from "../challenge.service";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { Observable } from "rxjs";
import { FormFields } from "app/views/campaign-3/components/form-fields/form-fields.component";
import { ChallengeExportReportDTO, ChallengePeriodOverviewChartesian, ChallengeResponse, GraphicsDTO, GraphicsDTOChartesian, LevelParticipation, NumericResults, ParticipantsOverviewSummary, PeriodOverviewChartesian } from "../challenge.model";
import { DatePipe } from "@angular/common";
import { FrequencyParam } from "app/views/baskets/baskets.model";
import { ChallengeOverviewService } from "../challenge-overview.service";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { ChallengeOverviewExportService } from "../challenge-overview-export.service";
import * as FileSaver from 'file-saver';
import { Campaign3KontableComponent } from "app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component";
import { ChallengeOverviewExportGraphicService } from "../challenge-overview-export-graphic.service";





interface ChartSeries {
  name: string;
  data: number[] | { name: string; y: number }[];
}

interface ChartConfig {
  chart: { type: string };
  title: { text: string };
  xAxis: { categories: string[] };
  series: ChartSeries[];
}

@Component({
  selector: 'app-challenge-graphics',
  templateUrl: './challenge-graphics.component.html',
  styleUrls: ['./challenge-graphics.component.css']
})


export class ChallengeGraphics implements OnInit {
  // campi di ricerca
  searchChallenge: ChallengeResponse;
  searchDateStart: Date
  searchEndDate: Date
  sampleFrequency: any;
  sampleFrenquencyList: Array<{ label: string; value: string, maxFreq: string }>;
  showExclusive: boolean = true;
  emptyLevels: boolean = false;
  selectedAcm: any;

  acmList: any;

  challengeList: ChallengeResponse[] = []
  @ViewChild('challengeField') challengeField: FormFields
  @ViewChild('start_date_field') startDateField: FormFields;
  @ViewChild('end_date_field') endDateField: FormFields;
  @ViewChild('sampleFrequencyField') sampleFrequencyField: FormFields
  @ViewChild('acm_field') acmField: FormFields


  //UI
  breadcrumbs: Array<BreadCrumbModel> = [];
  showBreadCrumb: boolean = false;
  dateErrorMessage: string = null;

  //RISPOSTE
  partecipantOverviewResponse: any;
  partecipantOverviewSummary: ParticipantsOverviewSummary;
  periodOverviewChartesian: ChallengePeriodOverviewChartesian;


  // stato caricamento
  dataLoaded: boolean = false;
  //vedere se inserire in Numeric Result
  // dati mappati con valori di default
  // dati mappati con valori di default
  numericResults: NumericResults = {
    totalPartecipant: 0,
    effectivePartecipant: 0,
    effectivePercentage: 0,
    activePartecipant: 0,
    activePartecipantPercentage: 0,
    levels: [],
    inclusiveLevels: [] // livelli dinamici
  };


  chartCartesian: ChartConfig = {
    chart: { type: 'line' },
    title: { text: '' },
    xAxis: { categories: [] },
    series: []
  };
  chartPie: ChartConfig = {
    chart: { type: 'pie' },
    title: { text: '' },
    xAxis: { categories: [] },
    series: []
  };
  chartBar: ChartConfig = {
    chart: { type: 'column' },
    title: { text: '' },
    xAxis: { categories: [] },
    series: []
  };

  readyAcm: boolean = false;
  showTableExport: boolean = false;
  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;
  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  noFilter = KontableComponent.NoFilter;
  frequencyRangeList: FrequencyParam[] = []


  //REPORT VARIABLE
  currentOpenedRow: number | null = null;
  displayDeleteDialog: boolean = false;
  reportToDelete: ChallengeExportReportDTO;
  showMenu: boolean = false;
  showPopupInfoDownload: boolean = false;
  showPopupInfoErrorExport: boolean = false;
  reportError: string;
  reportStateList: Array<{ value: string; label: string }> = [];
  @ViewChild('excellReportTable') excellReportTable: Campaign3KontableComponent;

  constructor(
    public router: Router,
    public srvCalendar: CalendarTranslateService,
    private srvNotify: MessageService,
    private translate: TranslateService,
    private challengeService: ChallengeService,
    private challengeOverviewExportGraphicService: ChallengeOverviewExportGraphicService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {

    const weekly$ = this.translate.get('challenge.weekly');
    const monthly$ = this.translate.get('challenge.monthly');
    const yearly$ = this.translate.get('challenge.yearly');

    const challengeListTranslation$ = this.translate.get('challenge.challenge-list');
    const errorStartEnd$ = this.translate.get('campaign.error_start_end_date');
    const challengeList$ = this.challengeService.getChallenges();

    const frequencyRange$ = this.challengeService.getFrequencyParam();
    const stateTranslations$ = this.translate.get([
      'challenge.export_status_starting',
      'challenge.export_status_completed',
      'challenge.export_status_completed_no_data',
      'challenge.export_status_failed'
    ]);


    Observable.zip(
      weekly$,
      monthly$,
      yearly$,
      challengeListTranslation$,
      errorStartEnd$,
      challengeList$,
      frequencyRange$,
      stateTranslations$
    ).subscribe(function (results) {

      var weekly = results[0];
      var monthly = results[1];
      var yearly = results[2];
      var challengeListTrans = results[3];
      var resStartEnd = results[4];
      var resChallengeList = results[5];
      var resfrequencyRange = results[6];
      var stateTranslations = results[7];

      this.frequencyRangeList = resfrequencyRange;


      const frequencyMap = this.frequencyRangeList.reduce((acc, item) => {
        acc[item.param_key] = item.param_code;
        return acc;
      }, {} as Record<string, string>);


      const keyMap: Record<string, string> = {
        WEEK: 'MAX.WEEKS.CHALLENGE',
        MONTH: 'MAX.MONTHS.CHALLENGE',
        YEAR: 'MAX.YEARS.CHALLENGE'
      };

      this.sampleFrenquencyList = [
        { label: weekly, value: 'WEEK', maxFreq: frequencyMap[keyMap.WEEK] || '' },
        { label: monthly, value: 'MONTH', maxFreq: frequencyMap[keyMap.MONTH] || '' },
        { label: yearly, value: 'YEAR', maxFreq: frequencyMap[keyMap.YEAR] || '' }
      ];

      // Breadcrumb
      this.breadcrumbs = [
        {
          code: 'bc1',
          description: challengeListTrans,
          routerLink: '/challenge-list'
        }
      ];

      // Messaggio errore date
      this.dateErrorMessage = resStartEnd;

      if (resChallengeList && resChallengeList.data) {
        this.challengeList = resChallengeList.data.map(function (item) {
          item.display = item.id + ' - ' + item.title + ' (' + item.description + ')';
          return item;
        });
      }
      this.reportStateList = [
        { value: null, label: '' },
        { value: '0', label: stateTranslations['challenge.export_status_starting'] },
        { value: '1', label: stateTranslations['challenge.export_status_completed'] },
        { value: '2', label: stateTranslations['challenge.export_status_completed_no_data'] },
        { value: '3', label: stateTranslations['challenge.export_status_failed'] }
      ];



      this.showBreadCrumb = true;
      this.showTableExport = true;
    }.bind(this));
  }



  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("Nessuna route implementata");
    }
  }
  maxEndDate: Date | null = null;
  onFrequencySelected(): void {

    // Se non ho frequenza selezionata
    if (!this.sampleFrequency || !this.sampleFrequency.value) {
      this.maxEndDate = null;
      return;
    }

    // Se non ho data di inizio → resetto tutto
    if (!this.searchDateStart) {
      this.maxEndDate = null;
      this.searchEndDate = null;
      return;
    }

    var selected = this.sampleFrenquencyList.find(function (f) {
      return f.value === this.sampleFrequency.value;
    }.bind(this));

    if (!selected || !selected.maxFreq) {
      this.maxEndDate = null;
      return;
    }

    var max = Number(selected.maxFreq);

    if (isNaN(max)) {
      this.maxEndDate = null;
      return;
    }

    // 🔥 Clono la data di partenza
    var maxDate = new Date(this.searchDateStart.getTime());

    switch (this.sampleFrequency.value) {

      case 'WEEK':
        maxDate.setDate(maxDate.getDate() + (max * 7));
        break;

      case 'MONTH':
        maxDate.setMonth(maxDate.getMonth() + max);
        break;

      case 'YEAR':
        maxDate.setFullYear(maxDate.getFullYear() + max);
        break;

      default:
        this.maxEndDate = null;
        return;
    }

    this.maxEndDate = maxDate;

    // ✅ PROBLEMA 1 RISOLTO:
    // Se la data di fine è oltre il massimo consentito → la resetto
    if (this.searchEndDate) {
      var endDate = new Date(this.searchEndDate.getTime());

      if (endDate.getTime() > this.maxEndDate.getTime()) {
        this.searchEndDate = null;
      }
    }
  }
  search(): void {

    if (!this.validateSearch()) {
      return;
    }
    const startDateFormatted = this.formatDateToDDMMYYYY(this.searchDateStart);
    const endDateFormatted = this.formatDateToDDMMYYYY(this.searchEndDate);
    const payloadGOOD: GraphicsDTO = {
      challengeId: this.searchChallenge.id,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      challengeAcmId: this.selectedAcm.value
    };
    //DA RIMUOVERE
    const payloadTEST: any = {
      challengeId: this.searchChallenge.id,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
    };

    const payloadChartesian: GraphicsDTOChartesian = {
      challengeId: this.searchChallenge.id,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      periodType: this.sampleFrequency.value,
      challengeAcmId: this.selectedAcm.value
    };

    //DA RIMUOVERE
    const payloadChartesianTest: any = {
      challengeId: this.searchChallenge.id,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      periodType: this.sampleFrequency.value,

    };
    const overview$ = this.challengeService.getOverviewComplete(payloadGOOD);
    const overviewCartesian$ = this.challengeService.getOverviewCompleteCartesian(payloadChartesian);

    Observable.zip(overview$, overviewCartesian$)
      .subscribe(([overviewRes, overviewCartesianRes]) => {

        if (overviewRes) {
          this.partecipantOverviewSummary = overviewRes;
        }

        if (overviewCartesianRes) {
          this.periodOverviewChartesian = overviewCartesianRes;
        }

        this.elaborateGraphicsData();
        this.dataLoaded = true;

      }, err => {
        console.error('Errore durante le chiamate API:', err);
      });
  }


  //elaborazione dei dati della risposta, divisa in funzioni
  elaborateGraphicsData(): void {
    const data = this.partecipantOverviewSummary;

    if (!data) {
      console.warn('Nessun dato disponibile per elaborare i grafici.');
      return;
    }

    this.mapNumericResults(data);
    this.buildLineChart();
    this.buildPieChart();
  }
  //Elaborazione dei dati della risposta per essere fruibili alla UI
  private mapNumericResults(data: any): void {

    this.numericResults = {
      totalPartecipant: data.totalParticipants || 0,
      effectivePartecipant: data.effectiveParticipants || 0,
      effectivePercentage: data.effectivePercentage || 0,
      activePartecipant: data.activeParticipants || 0,
      activePartecipantPercentage: data.activePercentage || 0,
      levels: [],
      inclusiveLevels: []
    };

    const levels = data.levelParticipationExclusive || [];
    const levelsInclusive = data.levelParticipationInclusive;

    this.numericResults.levels = levels.map((lvl: LevelParticipation) => ({
      id: lvl.challengeDetailId,
      title: lvl.challengeDetailTitle,
      participants: lvl.participants || 0,
      percentage: (lvl.participantsPercentage || 0)
    }));

    this.numericResults.inclusiveLevels = levelsInclusive.map((lvl: LevelParticipation) => ({
      id: lvl.challengeDetailId,
      title: lvl.challengeDetailTitle,
      participants: lvl.participants || 0,
      percentage: (lvl.participantsPercentage || 0)
    }));
    if (this.numericResults.levels.length != 0 && this.numericResults.inclusiveLevels.length != 0) {
      this.emptyLevels = false;
    } else {
      this.emptyLevels = true;
    }
    console.log('✅ numericResults aggiornato:', this.numericResults);
    console.log(this.showExclusive, this.emptyLevels)
  }



  //CARTESIANO
  private buildLineChart(): void {

    console.group('📈 buildLineChart — Andamento partecipanti');

    let canBuild = true;

    // 🔍 Validazione dati
    console.group('🔍 Validazione dati');

    if (!this.periodOverviewChartesian) {
      console.warn('periodOverviewChartesian assente');
      canBuild = false;
    } else if (!this.periodOverviewChartesian.periods) {
      console.warn('periods assente');
      canBuild = false;
    } else if (this.periodOverviewChartesian.periods.length === 0) {
      console.warn('periods vuoto');
      canBuild = false;
    } else {
      console.info(
        'Periodi disponibili:',
        this.periodOverviewChartesian.periods.length
      );
    }

    console.groupEnd();

    if (canBuild) {

      const periods = this.periodOverviewChartesian.periods;

      // 🔃 Ordinamento periodi
      console.group('🔃 Ordinamento periodi');

      periods.sort((a, b) => {
        return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
      });

      console.log(
        'Primo periodo:',
        periods[0].startDate,
        '| Ultimo periodo:',
        periods[periods.length - 1].startDate
      );

      console.groupEnd();

      // 🏷️ Categorie asse X
      console.group('🏷️ Costruzione asse X');
      const categories = periods.map(p =>
        this.buildXAxisLabel(p, this.sampleFrequency)
      );
      console.log('Categorie X:', categories);

      console.groupEnd();

      // 📊 Serie dati
      console.group('📊 Costruzione serie');

      const activeParticipantsSeries = periods.map(p => p.activeParticipants);
      const effectiveParticipantsSeries = periods.map(p => p.effectiveParticipants);

      console.log('Serie partecipanti attivi:', activeParticipantsSeries);
      console.log('Serie partecipanti effettivi:', effectiveParticipantsSeries);

      console.groupEnd();

      // 🧱 Configurazione grafico
      console.group('🧱 Configurazione grafico');

      this.chartCartesian = {
        chart: {
          type: 'line'
        },
        title: {
          text: 'Andamento partecipanti nel tempo'
        },
        xAxis: {
          categories
        },
        series: [
          {
            name: 'Partecipanti attivi',
            data: activeParticipantsSeries
          },
          {
            name: 'Partecipanti effettivi',
            data: effectiveParticipantsSeries
          }
        ]
      };

      console.info('Grafico cartesiano costruito correttamente ✅');

      console.groupEnd();
    }

    if (!canBuild) {
      this.chartCartesian = null;
      console.warn('Grafico cartesiano NON costruito ❌');
    }

    console.groupEnd();
    return;
  }


  private buildXAxisLabel(period: any, frequency: string): string {

    let label = '';
    let startDate: Date;
    let endDate: Date | null = null;

    if (period && period.startDate) {
      startDate = new Date(period.startDate);

      if (period.endDate) {
        endDate = new Date(period.endDate);
      }

      if (frequency === 'WEEK') {
        const startDay = startDate.getDate();
        const endDay = endDate ? endDate.getDate() : startDay;
        const month = startDate.toLocaleString('it-IT', { month: 'short' });
        const year = startDate.toLocaleString('it-IT', { year: '2-digit' });

        label = startDay + '–' + endDay + ' ' + month + ' ' + year;
      }

      if (frequency === 'MONTH') {
        label = startDate.toLocaleString('it-IT', {
          month: 'short',
          year: '2-digit'
        });
      }

      if (frequency === 'YEAR') {
        label = startDate.getFullYear().toString();
      }

      if (!label) {
        label = startDate.toLocaleDateString('it-IT');
      }
    }

    return label;
  }


  // Build del grafico a torta (livelli + inattivi)
  private buildPieChart(): void {

    console.group('🍰 buildPieChart (semplificata)');

    let canBuild = true;
    let levelData: any[] = [];
    let totalPercentage = 0;

    if (
      !this.numericResults ||
      !this.numericResults.levels ||
      this.numericResults.levels.length === 0
    ) {
      console.warn('Nessun livello disponibile');
      canBuild = false;
    }

    if (canBuild) {

      for (let i = 0; i < this.numericResults.levels.length; i++) {
        const lvl = this.numericResults.levels[i];

        const percentage =
          lvl && lvl.percentage != null
            ? lvl.percentage
            : 0;

        if (percentage > 0) {
          levelData.push({
            name: lvl && lvl.title ? lvl.title : 'Senza titolo',
            y: percentage
          });

          totalPercentage += percentage;
        }
      }

      const remainingPercentage = 100 - totalPercentage;

      if (remainingPercentage > 0) {
        levelData.push({
          name: 'Clienti che non hanno raggiunto livelli',
          y: remainingPercentage
        });
      }

      if (Math.abs(totalPercentage + remainingPercentage - 100) > 0.5) {
        console.warn('⚠️ Somma percentuali != 100', totalPercentage);
      }

      this.chartPie = {
        chart: { type: 'pie' },
        title: { text: 'Distribuzione partecipanti' },
        xAxis: { categories: [] },
        series: [{
          name: 'Percentuali',
          data: levelData
        }]
      };

      console.info('Grafico a torta costruito correttamente ✅');
    }

    if (!canBuild) {
      this.chartPie = null;
      console.warn('Grafico NON costruito ❌');
    }

    console.groupEnd();
    return;
  }





  //funzione di validazione dei campi filtri
  validateSearch(): boolean {
    let isValid = true;

    // Validazione campi SEMPRE presenti
    this.challengeField.performValidation();
    this.startDateField.performValidation();
    this.endDateField.performValidation();
    this.sampleFrequencyField.performValidation();

    // Validazione ACM solo se presente
    if (this.acmField) {
      this.acmField.performValidation();
    }

    // Controllo validità campi obbligatori
    if (
      !this.challengeField.valid ||
      !this.startDateField.valid ||
      !this.endDateField.valid ||
      !this.sampleFrequencyField.valid ||
      (this.acmField && !this.acmField.valid)
    ) {
      console.warn('Form non valido');
      isValid = false;
    }

    // Controllo coerenza date
    if (this.searchDateStart && this.searchEndDate) {
      const start = new Date(this.searchDateStart);
      const end = new Date(this.searchEndDate);

      if (start >= end) {
        this.startDateField.valid = false;
        this.endDateField.valid = false;

        this.startDateField.errorMessage = this.dateErrorMessage;
        this.endDateField.errorMessage = this.dateErrorMessage;

        console.warn('Date incongruenti');
        isValid = false;
      }
    }

    return isValid;
  }

  //EXPORT dei risultati numerici
  onExportParticipants(): void {
    const payload: GraphicsDTO = this.buildGraphicsPayload();

    this.challengeService.exportOverviewParticipants(payload).subscribe({
      next: (res: Blob) => {
        console.log('Export Overview Participants completato:', res);
        this.excellReportTable.refresh();
      },
      error: (err) => console.error('❌ Errore durante l’export dei partecipanti:', err)
    });
  }

  //EXPORT dei grafici
  onExportComplete(): void {
    const payload: GraphicsDTO = this.buildGraphicsPayload();

    this.challengeService.exportOverviewComplete(payload).subscribe({
      next: (res: Blob) => {
        console.log('Export Overview Complete completato:', res);
      },
      error: (err) => console.error('❌ Errore durante l’export completo:', err)
    });
  }

  buildGraphicsPayload(): GraphicsDTO {
    const startDateFormatted = this.formatDateToDDMMYYYY(this.searchDateStart);
    const endDateFormatted = this.formatDateToDDMMYYYY(this.searchEndDate);

    const payloadGOOD: GraphicsDTO = {
      challengeId: this.searchChallenge.id || null,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      challengeAcmId: this.selectedAcm.value
    };

    console.log('📦 Payload creato:', payloadGOOD);
    return payloadGOOD;
  }



  formatDateToDDMMYYYY(date: Date | string): string {
    let result = '';

    if (date) {
      const transformed = this.datePipe.transform(date, 'dd-MM-yyyy');
      if (transformed !== null) {
        result = transformed;
      }
    }

    return result;
  }

  /**
   * Converte una stringa "YYYY-MM-DD" o un oggetto Date in Date.
   * Restituisce null se invalida.
   */
  formatToDate(dateInput: Date | string): Date | null {
    if (!dateInput) return null;

    if (dateInput instanceof Date) {
      return isNaN(dateInput.getTime()) ? null : dateInput;
    }

    // input come "YYYY-MM-DD"
    const parts = (dateInput as string).split('-');
    if (parts.length !== 3) return null;

    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // 0-based
    const day = parseInt(parts[2], 10);

    const d = new Date(year, month, day);
    return isNaN(d.getTime()) ? null : d;
  }



  onChallengeSelected() {
    console.log(this.searchChallenge);

    // Cambiando challenge il range di date cambia: la frequenza selezionata
    // in precedenza (e il relativo cap calcolato su quel range) non sono più validi.
    this.sampleFrequency = null;
    this.maxEndDate = null;

    const selectedChallenge = this.searchChallenge && this.searchChallenge;
    this.readyAcm = false;
    if (!selectedChallenge || !selectedChallenge.id) {
      this.acmList = [];
      this.readyAcm = true;
      return;
    }
    this.challengeService.getChallengeAcm(selectedChallenge.id).subscribe({
      next: (response: any[]) => {
        if (response && response.length > 0) {
          this.acmList = response.map(item => ({
            value: item.id,
            label: item.acmId.description
          }));
          //  AUTO-SELEZIONE se uno solo
          if (this.acmList.length === 1) {
            this.selectedAcm = this.acmList[0];
          }
        } else {
          this.acmList = [];
        }
        this.readyAcm = true;
      },
      error: (error) => {
        console.error('Errore durante il recupero degli ACM:', error);
        this.acmList = [];
        this.readyAcm = true;
      }
    });


    if (this.searchChallenge.dateStart && this.searchChallenge.dateEnd) {

      const startDateStr = this.searchChallenge.dateStart;
      const endDateStr = this.searchChallenge.dateEnd;

      const startDate = this.formatToDate(startDateStr);
      const endDate = this.formatToDate(endDateStr);

      this.searchDateStart = startDate;
      this.searchEndDate = endDate;

      this.endDateField.minDate = startDate;
      this.endDateField.maxDate = endDate;
    }
  }
  showOnlyExclusive() {
    if (!this.showExclusive) {
      this.showExclusive = true;
    }
  }

  showOnlyInclusive() {
    if (this.showExclusive) {
      this.showExclusive = false;
    }
  }


  //NEW REPORT FUNCTION


  deleteReport(row: ChallengeExportReportDTO) {
    this.showMenu = false;
    this.reportToDelete = row;
    this.displayDeleteDialog = true;
  }
  closePopupDelete(): void {
    this.displayDeleteDialog = false;
  }
  onDefinitiveDelete(row: ChallengeExportReportDTO): void {
    this.challengeOverviewExportGraphicService.deleteReport(row.id).subscribe({
      next: () => {
        this.displayDeleteDialog = false;

        this.srvNotify.add({
          severity: 'success',
          summary: this.translate.instant('common.success'),
          detail: this.translate.instant('challenge.delete_success'),
          life: 5000
        });

        this.excellReportTable.refresh();
      },
      error: (err) => {
        console.error('Errore durante la cancellazione challenge:', err);

        this.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('challenge.delete_error'),
          life: 5000
        });
      }
    });
  }



  obtainReport(row: ChallengeExportReportDTO) {
    this.challengeOverviewExportGraphicService.obtainReport(row.id).subscribe({
      next: (res: any) => {
        this.displayDeleteDialog = false;

        // Estraggo solo l'ultima parte del percorso del file
        let fileName = row.fileName || 'report.csv';
        if (fileName.includes('/') || fileName.includes('\\')) {
          fileName = fileName.split(/[\\/]/).pop();
        }

        const reader = new FileReader();
        reader.onload = () => {
          try {
            const jsonRes = JSON.parse(reader.result as string);
            if (jsonRes && jsonRes.rsp_data) {
              const csvBlob = new Blob([jsonRes.rsp_data], { type: 'text/csv' });
              FileSaver.saveAs(csvBlob, fileName);
            }
          } catch (e) {
            console.error('Errore durante il parsing del JSON dal Blob:', e);
          }
        };
        reader.readAsText(res);

        this.srvNotify.add({

          severity: 'success',
          summary: this.translate.instant('common.success'),
          detail: this.translate.instant('challenge.obtain_success'),
          life: 5000
        });
        this.showMenu = false;

        this.excellReportTable.refresh();
      },
      error: (err) => {
        console.error('Errore durante l’ottenimento challenge:', err);

        this.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('challenge.obtain_error'),
          life: 5000
        });
      }
    });
  }

  infoErrorExport(row: ChallengeExportReportDTO): void {
    this.reportError = row.error;
    this.showPopupInfoErrorExport = true;
  }
  onClosePopupInfoErrorExport(): void {
    this.showPopupInfoErrorExport = false;
  }





  onClosePopupInfoDownload(): void {
    this.showPopupInfoDownload = false;
  }
  getFileName(path: string): string {
    if (!path) {
      return 'not-found';
    }
    const normalizedPath = path.replace(/\\/g, '/');
    return normalizedPath.substring(normalizedPath.lastIndexOf('/') + 1);
  }

  toggleMenu(row: ChallengeExportReportDTO): void {
    var id = row.id;

    if (this.showMenu && this.currentOpenedRow !== id) {
      this.showMenu = false;
    }

    this.currentOpenedRow = id;
    this.showMenu = !this.showMenu;
  }
  @HostListener('document:click', ['$event'])
  onClick(event: any): void {
    var target = event.target;

    if (
      (!target.closest || !target.closest('.dropdown-menu')) &&
      (!target.closest || !target.closest('.d-flex'))
    ) {
      this.showMenu = false;
    }
  }

  loadStateList() {
    this.reportStateList = [
      { value: null, label: '' },
      { value: '0', label: this.translate.instant('challenge.export_status_starting') },
      { value: '1', label: this.translate.instant('challenge.export_status_completed') },
      { value: '2', label: this.translate.instant('challenge.export_status_completed_no_data') },
      { value: '3', label: this.translate.instant('challenge.export_status_failed') }
    ];
  }

  getReportStatus(value: string): string {
    const item = this.reportStateList.find(rs => rs.value === value); // ora confronto stretto
    return item ? item.label : 'Unknown';
  }



}








// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-graphics/challenge-graphics.component.ts